import React,{ useRef,useState } from 'react';
import './App.css';
import { Routes, Route,useParams } from "react-router-dom";
import MainPage from './960x540/MainPage';
import PreviewPage from './960x540/PreviewPage';
import Page404 from './960x540/Page404';
import Test from './960x540/Test';


function App() {
    const config = { 
        hostApi : process.env.REACT_APP_API,
        hostApp : 'https://vision.net.last40.com/app/',
        hostMob : 'https://netvision.last40.com/m/',
      }

  React.useEffect(() => {
  }, []);

  return (
    <Routes>
      <Route path="*" element={<Page404 />} />
      <Route path="/app/:id" element={<MainPage config={config} />} />
      <Route path="/prev/:id" element={<PreviewPage config={config} />} />
      <Route path="/test/:id" element={<Test config={config} />} />
    </Routes>
  );
}

export default App;
